<template>
  <div>
    <b-modal
      id="terms"
      centered
      title="Terms & Conditions"
      ok-only
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @ok="onSubmit"
      ok-title="Accept Terms"
    >
      <b-form @submit="onSubmit">
        <p class="my-4">
          To continue using please accept the
          <a href="/terms" target="_blank" style="color: #007bff">Terms & Conditions.</a>
        </p>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

import { handleGlobalError } from '../../util'
export default {
  mounted() {
    setTimeout(() => {
      this.checkUserAgreement()
    }, 300)
  },
  methods: {
    async checkUserAgreement() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_PXL_API}/terms-log`)
        if (!response.data.length) {
          this.$bvModal.show('terms')
        }
      } catch (error) {
        console.error('error trying to get user terms acceptance', error)
        handleGlobalError(this, error, 'getting user terms acceptance')
      }
    },
    async onSubmit() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/terms-log`, {
          version: 1.0,
          applicationName: 'pxl-games',
        })
        this.successToast()
        this.$nextTick(() => {
          this.$bvModal.hide('terms')
        })
      } catch (error) {
        console.error('error trying to accept user terms acceptance', error)
        handleGlobalError(this, error, 'accepting Terms & Conditions')
      }
    },
    successToast() {
      this.$bvToast.toast('Successfully accepted Terms & Conditions.', {
        title: 'Terms & Conditions',
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
      })
    },
  },
}
</script>
